import {forwardRef} from "react";

import {useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const EditInput = forwardRef((props, ref) => {
  const {isMobile} = useSelector((state) => state.common.settings);
  const {
    width,
    fontSize,
    label,
    placeholder,
    type,
    value,
    required,
    onChange,
    onFocus,
    validation,
  } = props;

  const handleChange = (e) => {
    const newValue = e.target.value;

    if (validation && typeof validation === "function") {
      const isValid = validation(newValue);

      if (!isValid) {
        return;
      }
    }

    onChange && onChange(e);
  };

  return (
    <input
      ref={ref}
      placeholder={placeholder}
      className={styles.editInput}
      type={type}
      value={value}
      onChange={handleChange}
      onFocus={onFocus}
      aria-label={label}
      required={required}
      style={
        !isMobile
          ? {width: `${width}rem`, fontSize: fontSize ? `${fontSize}rem` : ""}
          : {width: `100%`, fontSize: fontSize ? `${fontSize}rem` : ""}
      }
    />
  );
});
